import React, { useEffect, useState } from "react";
import $ from "jquery";
import "turn.js";
import Turn from "../Turn";
import DesktopTurn from "../DesktopTurn";



const options = {
  width: 600,
  height: window.innerHeight,
  autoCenter: true,
  display: "single",
  acceleration: true,
  elevation: 50,
  gradients: !$.isTouch,
  when: {
    turned: function(e, page) {
      console.log("Current view: ", $(this).turn("view"));
    }
  }
};

const options2 = {
  width: "100%",
  height: window.innerHeight,
  autoCenter: true,
  display: "single",
  acceleration: true,
  elevation: 50,
  gradients: !$.isTouch,
  when: {
    turned: function(e, page) {
      console.log("Current view: ", $(this).turn("view"));
    }
  }
};

const pages = [
  "https://raw.github.com/blasten/turn.js/master/demos/magazine/pages/01.jpg",
  "https://raw.github.com/blasten/turn.js/master/demos/magazine/pages/02.jpg",
  "https://raw.github.com/blasten/turn.js/master/demos/magazine/pages/03.jpg",
  "https://raw.github.com/blasten/turn.js/master/demos/magazine/pages/04.jpg",
  "https://raw.github.com/blasten/turn.js/master/demos/magazine/pages/05.jpg",
  "https://raw.github.com/blasten/turn.js/master/demos/magazine/pages/06.jpg"
];

const CommicBook = () => {
  const [mobile, setMobile] = useState(false)

  return (
      <Turn options={options2} className="magazine">
        {pages.map((page, index) => (
          <div key={index} className="page">
              {
                index === 1 
                ?
                <div style={{width:'100%', height:'100%', backgroundColor:'green',
                display:'flex', alignItems:'center', justifyContent:'center'
              }}>
                          <p>Card 1</p>
                  </div>
                  :
                  <img draggable={false} src={page} alt="" />
                  
                }
          </div>
        ))}
      </Turn>
  );
};

export default CommicBook
